module.exports = __webpack_public_path__ + "images/testimonial-360.webp";